/**
 * Created by tom 16/11/21
 **/
import {Feature} from "ol";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {ICoordinateAdjustmentService} from "../services/coordinate-adjustment";

interface FeatureFieldsBindings {
    feature: Feature
}

class FeatureFieldsController implements ng.IComponentController, FeatureFieldsBindings {
    constructor(protected mapService: IMapService,
                protected coordinateAdjustmentService: ICoordinateAdjustmentService) {
    }

    feature;

    fields: [string, string|number][] = [];

    title() {
        const firstField = this.fields.length && this.fields[0];
        return firstField ? firstField[1] : 'Unnamed feature';
    }

    $onChanges(onChangesObj: ng.IOnChangesObject): void {
        if ('feature' in onChangesObj) {
            this.fields = [];
            const feature = onChangesObj['feature'].currentValue as Feature;
            if (feature) {
                const fields = feature.get('fields');
                if (!Array.isArray(fields)) {
                    return;
                }

                this.fields = fields.map(field => {
                    return [field, feature.get(field)];
                });
                console.log(this.fields);
            }
        }
    }

    zoomTo() {
        const extent = this.feature.getGeometry().getExtent();
        const map = this.mapService.map;
        map.getView().fit(extent,
            <any> { // Typings are out of date....
                size: map.getSize(),
                padding: this.coordinateAdjustmentService.padding([10, 10, 10, 10])
            });
    }
}

export class FeatureFields implements ng.IComponentOptions {
    controller = ['landcareMapService', 'coordinateAdjustmentService', FeatureFieldsController];

    bindings = {
        feature: '<'
    }

    template =
`<div>
    <button class="div-like link-like" 
        title="Zoom to"
        ng-click="$ctrl.zoomTo($event)"
        ng-mouseover="$ctrl.feature.set('hover', true)"
        ng-mouseleave="$ctrl.feature.set('hover', false)"><h4>Feature {{ $ctrl.title() }}</h4></button>
    <table class="table table-condensed">
    <tbody>
        <tr ng-repeat="field in $ctrl.fields" class="feature-field">
            <th>{{ field[0] }}</th>
            <td>{{ field[1] }}</td>
        </tr>
    </tbody>        
    </table>
</div>`
}